module.exports = __webpack_public_path__ + "img/2-1.8480a1f2.png";